<div [matTooltip]="tooltip"
    class="w-fit {{padding}} mr-1 inline-block text-sm whitespace-nowrap font-semibold rounded-full {{bgColor}}">
</div>